// HealthCheck.js
import React, { useEffect } from 'react';

function HealthCheck() {
  useEffect(() => {
    // Resolve API base from environment variables
    const viteEnv = (typeof import.meta !== 'undefined' && import.meta && import.meta.env) ? import.meta.env : {};
    
    // Primary source: REACT_APP_RAILWAY_API_BASE_URL
    let API_BASE_URL = process.env.REACT_APP_RAILWAY_API_BASE_URL;
    
    // Fallback to Vite env var if CRA var not set
    if (!API_BASE_URL) {
      API_BASE_URL = viteEnv.VITE_RAILWAY_API_BASE_URL;
    }
    
    // In development mode only, allow localhost fallback
    if (!API_BASE_URL && process.env.NODE_ENV === 'development') {
      API_BASE_URL = 'http://localhost:5001';
      console.log('Development mode: using localhost fallback');
    }
    
    // Error if no API base URL configured in non-development environments
    if (!API_BASE_URL) {
      console.error('API base URL not configured');
      return; // Don't attempt health check without valid API base
    }

    const url = `${API_BASE_URL.replace(/\/+$/, '')}/health-check`;

    console.log('HealthCheck useEffect running');
    console.log('Pinging backend at:', url);

    fetch(url)
      .then((res) => res.json())
      .then((data) => console.log('Backend health:', data))
      .catch((err) => console.error('Error pinging backend:', err));
  }, []);

  return null; // This component doesn't render anything visible
}

export default HealthCheck;